module.exports = __webpack_public_path__ + "static/media/no-members.17175c10.svg";